import React from 'react';
import backbone from '../../Media/backbone.png'

const Section2 = () => {
    return (
        <div className='bg-pic-2 bg-cover'>
            <div className='w-11/12 mx-auto text-center py-28'>
                <h2 className='text-white font-bold text-3xl md:text-5xl'>Unleash Your Potential & Improve Patient Outcomes</h2>
                <p className='text-gray-100 text-lg my-5'>PEPID’s content is specifically designed for you</p>
                <p className='text-orange-300 text-2xl font-bold'>Please Choose Your Role or Profession</p>
                <div className='flex justify-center my-5'>
                    <div className='grid grid-cols-12 gap-5'>
                        <p className='text-sm font-bold px-4 py-2 rounded-full bg-white text-primary-600 col-span-6 md:col-span-3'>PRACTICING<br />PROFESSIONAL</p>
                        <p className='text-sm font-bold px-4 py-2 rounded-full bg-white text-primary-600 col-span-6 md:col-span-3'>HOSPITAL & HEALTH<br />SYSTEMS</p>
                        <p className='text-sm font-bold px-4 py-2 rounded-full bg-white text-primary-600 col-span-6 md:col-span-3'>INSTITUTION OR<br />GROUP</p>
                        <p className='text-sm font-bold px-4 py-2 rounded-full bg-white text-primary-600 col-span-6 md:col-span-3'>STUDENT OR<br />RESIDENT</p>
                    </div>
                </div>
                <div className='flex justify-end'>
                    <img src={backbone} alt="" />
                </div>
            </div>
        </div>
    );
};

export default Section2;